module.exports = __webpack_public_path__ + "img/collection-engagementRingsFastDelivery.65efbf6.jpg";